import { getNewsData } from '@/api/system.api.js'

import { isMobile } from '@/utils/common.js'

export default {
  props: {
    newsPicList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      swiperList: [],
      news: {},
    }
  },
  created() {
    this.getNewsData()
  },
  methods: {
    async getNewsData() {
      const latestList = await this.getNewsListByType('last')
      const newsList = await this.getNewsListByType('news')
      const tipsList = await this.getNewsListByType('strategy')
      const activityList = await this.getNewsListByType('activity')
      this.news = {
        "latest": latestList,
        "news": newsList,
        "tips": tipsList,
        "activity": activityList,
      }
      this.swiperList = this.newsPicList
    },
    async getNewsListByType(type) {
      const list = await getNewsData({
        page: 1,
        limit: isMobile() ? 5 : 6,
      }, type)
        .then((res) => {
          let list = []
          for (let i = 0; i < res.list.length; i++) {
            list.push({
              id: res.list[i].id,
              tag: res.list[i].tag,
              title: res.list[i].title,
              time: new Date(res.list[i].createtime * 1000).toLocaleDateString('zh-cn'),
              description: res.list[i].desc,
            })
          }

          return list
        })
        .catch(() => {
          return []
        })

      return list
    },
  },
}